<form
	#editForm="ngForm"
	[formReset]="editForm"
	(ngSubmit)="editForm.valid && submit()">
	<div class="modal-header">
		<h4 class="modal-title">
			<span *ngIf="project?.id">
				{{'labels.project-edit' | translate}} {{project.name}}
			</span>
			<span *ngIf="!project?.id">{{'labels.project-create' | translate}}</span>
		</h4>
		<button
			type="button"
			class="close"
			aria-label="Close"
			(click)="dismiss()">
			<span aria-hidden="true">×</span>
		</button>
	</div>
	<div
		class="modal-body"
		ngbAutofocus>
		<div
			class="row"
			*ngIf="loading">
			<div class="col text-center">
				<app-loader
					[dark]="true"
					[material]="false"></app-loader>

			</div>
		</div>

		<div
			class="row"
			*ngIf="warning">

			<div class="col-md-12 alert alert-warning">{{warning}}</div>
		</div>

		<div
			class="row"
			*ngIf="errormessage">

			<div class="col-md-12 alert alert-danger">{{errormessage}}</div>
		</div>
		<ng-container *ngIf="!loading && project">
			<div class="row">

				<!-- company -->
				<div class="form-group col-md-4">
					<label for="company">{{ 'labels.company' | translate }}*</label>
					<ng-template [ngIf]="companyid || !project.isDraft">
						<input
							name="companyinput"
							[placeholder]="selected.company?.name"
							required
							type="text"
							class="form-control"
							disabled>
					</ng-template>
					<ng-template [ngIf]="!companyid && project.isDraft">
						<app-entity-autocomplete
							entityName="company"
							entityField="name"
							entityFilterType="like"
							[entitySearch]="search.company"
							name="company"
							[(ngModel)]="selected.company"
							placeholder
							required
							#companyautocomp="ngModel"
							[ngClass]="{'is-invalid': editForm.submitted && companyautocomp.invalid}">
						</app-entity-autocomplete>

						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && companyautocomp.invalid"
							style="display: block;">
							{{'errors.required' | translate}}
						</div>
					</ng-template>
				</div>

				<!-- tender -->
				<div class="form-group col-md-4">
					<label for="company">{{ 'labels.tender' | translate }}*</label>
					<ng-template [ngIf]="!project.isDraft">
						<input
							name="companyinput"
							[placeholder]="selected.company?.name"
							required
							type="text"
							class="form-control"
							disabled>
					</ng-template>
					<ng-template [ngIf]="project.isDraft">
						<app-entity-autocomplete
							[entityClass]="tenderClass"
							entityName="tender"
							entityField="name"
							entityFilterType="like"
							[entitySearch]="search.tender"
							name="tender"
							[(ngModel)]="selected.tender"
							placeholder
							required
							#tenderautocomp="ngModel"
							[ngClass]="{'is-invalid': editForm.submitted && tenderautocomp.invalid}">
						</app-entity-autocomplete>

						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && tenderautocomp.invalid"
							style="display: block;">
							{{'errors.required' | translate}}
						</div>
					</ng-template>

				</div>

				<!-- name -->
				<div class="form-group col-md-6">
					<label for="cname">{{ 'labels.name' | translate }}*</label>
					<input
						[disabled]="!project.isDraft"
						[(ngModel)]="project.name"
						#name="ngModel"
						name="name"
						required
						type="text"
						class="form-control"
						id="name"
						placeholder="{{ 'labels.name' | translate }}"
						[ngClass]="{'is-invalid': editForm.submitted && name.invalid}">
					<div
						class="invalid-feedback"
						*ngIf="editForm.submitted && name.invalid">
						{{'errors.required' | translate}}
					</div>
				</div>

				<!-- shortcode -->
				<div class="form-group col-md-6">
					<label for="cname">{{ 'labels.shortcode' | translate }}*</label>
					<input
						[disabled]="!project.isDraft"
						[(ngModel)]="project.shortcode"
						#shortcode="ngModel"
						name="shortcode"
						required
						type="text"
						class="form-control"
						id="shortcode"
						placeholder="{{ 'labels.shortcode' | translate }}"
						[ngClass]="{'is-invalid': editForm.submitted && shortcode.invalid}">
					<div
						class="invalid-feedback"
						*ngIf="editForm.submitted && shortcode.invalid">
						{{'errors.required' | translate}}
					</div>
				</div>
				<!-- keyword -->
				<div class="form-group col-md-6">
					<label for="cname">{{ 'labels.keyword' | translate }}*</label>
					<input
						[disabled]="!project.isDraft"
						[(ngModel)]="project.keyword"
						#keyword="ngModel"
						name="keyword"
						required
						type="text"
						class="form-control"
						id="keyword"
						placeholder="{{ 'labels.keyword' | translate }}"
						[ngClass]="{'is-invalid': editForm.submitted && keyword.invalid}">
					<div
						class="invalid-feedback"
						*ngIf="editForm.submitted && keyword.invalid">
						{{'errors.required' | translate}}
					</div>
				</div>
				<!-- budget -->
				<div class="form-group col-md-6">
					<label>{{'labels.budget' | translate}}*</label>
					<input
						[disabled]="!selected.tender || !project.isDraft"
						type="number"
						class="form-control"
						name="budget"
						[(ngModel)]="project.budget"
						required
						#budget="ngModel"
						[ngClass]="{'is-invalid': editForm.submitted && budget.invalid}">
					<div
						class="invalid-feedback"
						*ngIf="editForm.submitted && budget.invalid">
						{{'errors.required' | translate}}
					</div>
				</div>

				<!-- startdate -->
				<div class="form-group col-md-6">
					<label>{{'labels.startdate' | translate}}*</label>
					<app-datepicker
						[disabled]="!selected.tender || !project.isDraft"
						[(ngModel)]="project.startdate"
						name="startdate"
						[min]="selected.tender?.startdateasdate"
						[max]="selected.tender?.stopdateasdate"
						required
						#startdate="ngModel"
						[ngClass]="{'is-invalid': editForm.submitted && startdate.invalid}">
					</app-datepicker>
					<div
						class="invalid-feedback"
						*ngIf="editForm.submitted && startdate.invalid"
						style="display: block;">
						{{'errors.required' | translate}}
					</div>
				</div>

				<!-- enddate -->
				<div class="form-group col-md-6">
					<label>{{'labels.enddate' | translate}}*</label>
					<app-datepicker
						[disabled]="!selected.tender || !project.startdate || !project.isDraft"
						[(ngModel)]="project.enddate"
						name="enddate"
						[min]="project.startdateasdate"
						[max]="selected.tender?.stopdateasdate"
						required
						#enddate="ngModel"
						[ngClass]="{'is-invalid': editForm.submitted && enddate.invalid}">
					</app-datepicker>
					<div
						class="invalid-feedback"
						*ngIf="editForm.submitted && enddate.invalid"
						style="display: block;">
						{{'errors.required' | translate}}
					</div>
				</div>
				<div class="col-6">
					<span *ngIf="selected.tender">
						{{'tender.startdate' | translate}}:
						<b>
							{{selected.tender.startdate | date:'dd/MM/yyyy' }}
						</b>
					</span>
				</div>
				<div class="col-6">
					<span *ngIf="selected.tender">
						{{'tender.stopdate' | translate}}:
						<b>
							{{selected.tender.stopdate | date:'dd/MM/yyyy' }}
						</b>
					</span>
				</div>

				<!-- description -->
				<hr class="col mt-3">
				<div class="form-group col-md-12 mt-1">
					<label>{{ 'labels.description' | translate }}*</label>
					<textarea
						[disabled]="!project.isDraft"
						[(ngModel)]="project.description"
						#description="ngModel"
						name="description"
						required
						type="text"
						class="form-control"
						placeholder="{{ 'labels.description' | translate }}"
						[ngClass]="{'is-invalid': editForm.submitted && description.invalid}">
					</textarea>
					<div
						class="invalid-feedback"
						*ngIf="editForm.submitted && description.invalid">
						{{'errors.required' | translate}}
					</div>
				</div>
			</div>
			<hr class="col mt-3">
			<!-- status -->
			<div
				class="row"
				*ngIf="!isCompany">
				<div class="form-group col-md-6">
					<label>{{'status' | translate}}*</label>
					<select
						class="form-control custom-select"
						[(ngModel)]="project.status"
						required
						#status="ngModel"
						name="status"
						[ngClass]="{'is-invalid': editForm.submitted && status.invalid}">
						<option
							*ngFor="let u of statusoptions"
							[value]="u">
							{{u}}
						</option>
					</select>
					<div
						class="invalid-feedback"
						*ngIf="editForm.submitted && status.invalid"
						style="display: block;">
						{{'errors.required' | translate}}
					</div>
					<small>
						Attenzione: utilizzare i pulsanti per cambiare stato del progetto,
					cambiare lo stato manualmente può causare incoerenza nei dati se è già stata calcolata la rendicontazione.
					</small>
				</div>

				<div
					class="form-check col-md-12"
					*ngIf="project.isPresented">
					<input
						id="reporting"
						type="checkbox"
						name="reporting"
						[(ngModel)]="project.reporting">
					<label
						for="reporting"
						class="ml-1">
						Rendicontazione
					</label>
				</div>
			</div>
		</ng-container>
	</div>

	<div class="modal-footer">

		<button
			type="reset"
			class="btn btn-secondary">
			{{'labels.reset' | translate}}
		</button>
		<button
			type="button"
			class="btn btn-secondary"
			(click)="dismiss()">
			{{'labels.cancel' | translate}}
		</button>
		<button
			type="submit"
			class="btn btn-primary">
			{{'labels.save' | translate}}
		</button>
	</div>
</form>
